import { render, staticRenderFns } from "./change-password.page.vue?vue&type=template&id=b84ef2de&"
import script from "./change-password.page.vue?vue&type=script&lang=ts&"
export * from "./change-password.page.vue?vue&type=script&lang=ts&"
import style0 from "./change-password.page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QIcon,QSeparator});
